module.exports = require("@ember/template-compilation");